import SAPOMailConfig from '@/SAPOMailConfig';

export { BindSession as default };

/**
* Pools session to keep it alive
*
* @author      Rúben Simões <ruben.r.simoes@meo.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.1.0
*/
class BindSessionSingleton
{
    interval = null;

    last_bind_time = null;

    valid = false;

    session_hash = null;

    redirectOutside() {
        window.location = SAPOMailConfig.client.session.checkin_url;
        return true;
    }

    async refresh() {
        if (this.last_bind_time && (Date.now() - this.last_bind_time) < SAPOMailConfig.client.session.bind_interval) {
            return false;
        }

        this.stop();

        if (await this.call() === false) {
            return false;
        }

        this.start();
        return true;
    }

    async call() {
        var response = await fetch(SAPOMailConfig.client.session.checkin_url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        this.last_bind_time = Date.now();

        if (response.status !== 200) {
            this.setValid(false);
            return false;
        }

        if (!response || !response.headers) {
            this.setValid(false);
            return false;
        }

        this.session_hash = response.headers.get('X-PT-SS') || null;

        return true;
    }

    refreshValidity() {
        if (this.session_hash === null || this.session_hash !== SAPOMailConfig.server.account.shash) {
            this.setValid(false);
            return false;
        }

        this.setValid(true);
        return true;
    }

    setValid(valid) {
        this.valid = valid;
    }

    start() {
        this.interval = setInterval(async () => {
            if (await this.call() === false) {
                this.stop();
                this.redirectOutside();
                return;
            }
        }, SAPOMailConfig.client.session.bind_interval);
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }
}

const BindSession = new BindSessionSingleton();